export const uk2 = {
  colors: {
    primary: '#FF422B',
    background: 'linear-gradient(180deg, #FF913B 0%, #FF2525 100%)',
    text: '#333333',
  },
  fonts: {
    family: 'inter',
    weight: '700',
  },
  fontSizes: {
    small: '14px',
    medium: '16px',
    large: '20px', 
  },
  breakpoints: {
    xs: '320px',
    sm: '481px',
    md: '768px',
    lg: '1025px',
    xl: '1201px',
  },
};

export const midphase = {
  colors: {
    primary: '#FF422B',
    background: 'linear-gradient(180deg, #FF913B 0%, #FF2525 100%)',
    text: '#333333',
  },
  fonts: {
    family: 'inter',
    weight: '700',
  },
  fontSizes: {
    small: '14px',
    medium: '16px',
    large: '20px', 
  },
  breakpoints: {
    xs: '320px',
    sm: '481px',
    md: '768px',
    lg: '1025px',
    xl: '1201px',
  },
};

export const westhost = {
  colors: {
    primary: '#00B9E8',
    background: 'linear-gradient(180deg, #0062FF 0%, #2000D3 100%)',
    text: '#333333',
  },
  fonts: {
    family: 'inter',
    weight: '700',
  },
  fontSizes: {
    small: '14px',
    medium: '16px',
    large: '20px', 
  },
  breakpoints: {
    xs: '320px',
    sm: '481px',
    md: '768px',
    lg: '1025px',
    xl: '1201px',
  },
};

export const defaultPositions = {
  position: {
    desktop: {
      top: 'unset',
      right: 'unset',
      bottom: '32px',
      left: '32px',
    },
    mobile: {
      top: 'unset',
      right: '12px',
      bottom: '12px',
      left: 'unset',
    },
  },
};

export const FEEDBACK_PLACEMENT = {
  right: {
    right: '32px',
    left: 'unset'
  },

  left: {
    left: '32px',
    right: 'unset'
  }
}